import { render, staticRenderFns } from "./webdesign.html?vue&type=template&id=05ad860e&"
import script from "./webdesign.js?vue&type=script&lang=js&"
export * from "./webdesign.js?vue&type=script&lang=js&"
import style0 from "./webdesign.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports